import React from 'react';
import {InsightInterval, OperatorHardwareInsight} from "types/OperatorInsights";
import {ChartData, ChartOptions} from "chart.js";
import {toTitleCase} from "services/string";
import {Line as LineChart} from "react-chartjs-2";
import HoverAnnotation from "../../../plugins/hover-annotation";

// Types ----

type InteractionsChartProps = {
    data: OperatorHardwareInsight
    interval: InsightInterval
    compare: InsightInterval
}

// Component ----

function InteractionsChart({compare, data, interval}: InteractionsChartProps) {

    const chartData: ChartData<'line', any> = {
        labels: data.metrics.map(metric => metric.time),
        datasets: [
            // Beacons
            {
                label: "Beacons (Current period)",
                backgroundColor: "rgba(99, 102, 241, 0.8)",
                borderColor: "rgba(79, 70, 229, 1)",
                pointBackgroundColor: "rgba(99, 102, 241, 1)",
                data: data.metrics.map(metric => metric.measurements.beacon_interactions.value),
            },
            {
                label: `Beacons (Previous ${compare})`,
                backgroundColor: "rgba(99,102,241,0.4)",
                borderColor: "rgba(79, 70, 229, 0.4)",
                pointBackgroundColor: "rgba(99, 102, 241, 0.4)",
                data: data.metrics.map(metric => metric.measurements.beacon_interactions.comparison),
            },

            // Qr Codes
            {
                label: "QR Codes (Current period)",
                backgroundColor: "rgba(82,209,74,0.8)",
                borderColor: "rgb(121,222,114, 1)",
                pointBackgroundColor: "rgba(82,209,74,1)",
                data: data.metrics.map(metric => metric.measurements.qr_code_interactions.value),
            },
            {
                label: `QR Codes (Previous ${compare})`,
                backgroundColor: "rgba(82,209,74,0.4)",
                borderColor: "rgb(121,222,114, 0.4)",
                pointBackgroundColor: "rgba(82,209,74,0.4)",
                data: data.metrics.map(metric => metric.measurements.qr_code_interactions.comparison),
            }
        ],
    }

    const chartOptions: ChartOptions<'line'> = {
        plugins: {
            legend: {
                display: true,
            },
            tooltip: {
                mode: "index",
                intersect: false,
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: toTitleCase(interval)
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Interactions'
                },
                grid: {
                    display: true
                },
                min: 0
            }
        }
    }

    return (
        <LineChart data={chartData} options={chartOptions} plugins={[HoverAnnotation]}/>
    );
}

export default InteractionsChart;